export default "__VITE_ASSET__9e$AJ7tw__"